import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { RouterLink } from '@trello/router/router-link';

import type { OrganizationEntity } from './types';

interface OrganizationProps extends Pick<OrganizationEntity, 'id' | 'text'> {
  onClick?: () => void;
}

export const Organization: FunctionComponent<OrganizationProps> = ({
  text,
  id,
  onClick,
}) => {
  const organizationUrl = `/w/${id}`;

  return (
    <RouterLink href={organizationUrl} onClick={onClick}>
      {text || (
        <FormattedMessage
          id="templates.entity.an-organization"
          defaultMessage="a Workspace"
          description="The text used as a placeholder when no text is available."
        />
      )}
    </RouterLink>
  );
};
